import { Component, ChangeDetectionStrategy, ContentChildren, QueryList, AfterContentInit, ChangeDetectorRef, Input, HostListener, inject, Output, EventEmitter, ViewChildren, ElementRef } from '@angular/core';
import { TabPanelComponent } from './tab-panel/tab-panel.component';
import { CommonModule } from '@angular/common';
import { VariableHeadingComponent } from '@knorr-bremse-portals/ngx-components/components/variable-heading';
import { LEFT_ARROW, RIGHT_ARROW, scrollToElement } from '@knorr-bremse-portals/ngx-components';

@Component({
  selector: 'kb-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, VariableHeadingComponent ],
})
export class TabGroupComponent implements AfterContentInit {

  @Input() public label?: string;

  @ContentChildren(TabPanelComponent) protected panels!: QueryList<TabPanelComponent>;

  @Output() public readonly openPanelChange = new EventEmitter<TabPanelComponent>();

  @ViewChildren('headerButtonElement') private headerButtonElements!: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('panelElement') private panelElements!: QueryList<ElementRef<HTMLElement>>;

  public get openPanel(): TabPanelComponent {
    return this._openPanel;
  }
  private set openPanel(panel: TabPanelComponent) {
    this._openPanel = panel;
    this.openPanelChange.emit(panel);
  }
  private _openPanel!: TabPanelComponent;

  private openIndex!: number;

  private cdr = inject(ChangeDetectorRef);

  public ngAfterContentInit(): void {
    this.panels.changes.subscribe(() => this.cdr.markForCheck());

    const firstPanel = this.panels.get(0);
    if (firstPanel !== undefined) {
      this.open(firstPanel, false);
    }
  }

  public navigate(forward: boolean): void {
    const panels = this.panels.toArray();

    const targetIndex = ((this.openIndex + (forward ? 1 : -1)) + panels.length) % panels.length;
    const targetPanel = panels[targetIndex];
    this.open(targetPanel);
  }

  public openNext(): void {
    this.navigate(true);
  }

  public openPrevious(): void {
    this.navigate(false);
  }

  public open(panel: TabPanelComponent, focus = true): void {
    this.openPanel = panel;
    this.openIndex = this.panels.toArray().indexOf(panel);
    this.cdr.detectChanges();

    if (focus) {
      const headerButtonElement = this.headerButtonElements.map(e => e.nativeElement).find((e) => e.id === panel.headerId);
      if (headerButtonElement) {
        headerButtonElement.focus({
          preventScroll: true,
        });
        scrollToElement(headerButtonElement, {axis: 'x'});
      }

      const panelElement = this.panelElements.map(e => e.nativeElement).find((e) => e.id === panel.contentId);
      if (panelElement) {
        scrollToElement(panelElement, {axis: 'x'});
      }
    }
  }

  @HostListener('keydown', ['$event'])
  protected handleNavigation(event: KeyboardEvent): void {
    if (event.key === LEFT_ARROW) {
      this.openPrevious();
      event.preventDefault();
    } else if (event.key === RIGHT_ARROW) {
      this.openNext();
      event.preventDefault();
    }
  }

}
